import React, { useState, useEffect } from "react";
import { Button, Col, Row, notification } from "antd";
import axios from "axios";
import { DeviceIds } from "../helper/helper";
import {API_URL} from "../../../config";
import { ref, onValue } from "firebase/database";
import { database } from "../../../firebaseConfig";

const apiBaseUrl = API_URL;


const fetchDeviceData = async (appointmentId) => {
  try {
    const response = await axios.get(
      `${apiBaseUrl}/device/appointment_summary/?appointment_id=${appointmentId}`
      
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching device data:", error);
    return [];
  }
};

const combineBPData = (bpData) => {
  const sys = bpData.find((item) => item.device_id === DeviceIds.BPSys);
  const dia = bpData.find((item) => item.device_id === DeviceIds.BPDia);
  return sys && dia ? `${sys.value}/${dia.value} ${sys.units}` : "-";
};

const combineHeightWeightData = (hwData) => {
  const height = hwData.find((item) => item.device_id === DeviceIds.Height);
  const weight = hwData.find((item) => item.device_id === DeviceIds.Weight);
  return (
    <>
      <p>
        {height ? (
          <span>
            {height.value} {height.units}
          </span>
        ) : (
          "-"
        )}
        /
        {weight ? (
          <span>
            {weight.value} {weight.units}
          </span>
        ) : (
          "-"
        )}
      </p>
    </>
  );
};

const DeviceSection = ({ deviceStates, toggleDeviceState, appointmentId }) => {
  const [deviceData, setDeviceData] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);

  const devices = [
    {
      name: "Blood Pressure",
      key: "BP",
      groupId: 4,
      ids: [DeviceIds.BPSys, DeviceIds.BPDia],
    },
    {
      name: "Temperature",
      key: "Thermometer",
      groupId: 3,
      ids: [DeviceIds.Temperature],
    },
    { name: "SPO2", key: "SPO2", groupId: 5, ids: [DeviceIds.SPO2] },
    {
      name: "Body Fat",
      key: "FatPercentage",
      groupId: 2,
      ids: [DeviceIds.FatPercentage],
    },
    {
      name: "Height/Weight",
      key: "WeightHeight",
      groupId: 1,
      ids: [DeviceIds.Weight, DeviceIds.Height],
    },
  ];
  const isAnyDeviceRunning = Object.values(deviceStates).some(
    (state) => state === "Stop",
  );

  useEffect(() => {
    const appointmentRef = ref(database, `appointments/${appointmentId}`);
    
    const unsubscribe = onValue(appointmentRef, (snapshot) => {
      const appointmentData = snapshot.val();
      if (appointmentData?.last_updated !== lastUpdated) {
        setLastUpdated(appointmentData?.last_updated);
        handleApiCall(appointmentId); 
      }
    });

    return () => unsubscribe();
  }, [appointmentId, lastUpdated]);


  const fetchData = async () => {
    const initialData = {};
    for (const device of devices) {
      const data = await fetchDeviceData(appointmentId, device.groupId);
      initialData[device.key] = data.filter((item) =>
        device.ids.includes(item.device_id)
      );
    }
    setDeviceData(initialData);
  };

  
  const handleApiCall = async (appointmentId) => {
    await fetchData(); 
  };

  const handleButtonClick = async (deviceKey, deviceGroup) => {
    if (deviceKey === "FatPercentage") {
      const heightData = deviceData["WeightHeight"]?.find(
        (item) => item.device_id === DeviceIds.Height,
      );
      const weightData = deviceData["WeightHeight"]?.find(
        (item) => item.device_id === DeviceIds.Weight,
      );

      if (!heightData || !weightData) {
        notification.warning({
          message: "Measure Required",
          description: "Please measure Height and Weight first.",
        });
        return; 
      }
    }

    const newState = deviceStates[deviceKey] === "Start" ? "Stop" : "Start";
    toggleDeviceState(deviceKey, newState);

    if (newState === "Stop") {
      const data = await fetchDeviceData(appointmentId, deviceGroup);
      setDeviceData((prevData) => ({
        ...prevData,
        [deviceKey]: data.filter((item) =>
          devices
            .find((device) => device.key === deviceKey)
            .ids.includes(item.device_id),
        ),
      }));
    }
  };

  return (
    <React.Fragment>
      <Row gutter={[16, 16]}>
        <Col xs={16} sm={8} md={5} lg={8}>
          <h3>Vital</h3>
        </Col>
        <Col xs={16} sm={8} md={5} lg={8}>
          <h3>Reading</h3>
        </Col>
        <Col xs={16} sm={8} md={5} lg={8}>
          <h3>Action</h3>
        </Col>
      </Row>

      {devices.map((device) => (
        <Row gutter={[16, 16]} key={device.key}>
          <Col xs={16} sm={8} md={5} lg={8}>
            <h4>{device.name}</h4>
          </Col>
          <Col xs={16} sm={8} md={5} lg={8}>
            {deviceData[device.key] && deviceData[device.key].length > 0 ? (
              <div>
                {device.key === "BP" ? (
                  <p key="BP">{combineBPData(deviceData[device.key])}</p>
                ) : device.key === "WeightHeight" ? (
                  combineHeightWeightData(deviceData[device.key])
                ) : (
                  deviceData[device.key].map((data) => (
                    <p key={data.id}>
                      {data.value} {data.units ? data.units : ""}
                    </p>
                  ))
                )}
              </div>
            ) : (
              <p>-</p>
            )}
          </Col>
          <Col xs={16} sm={8} md={5} lg={8} style={{ marginTop: "10px" }}>
            <Button
              type="primary"
              onClick={() => handleButtonClick(device.key, device.groupId)}
              danger={deviceStates[device.key] === "Stop"}
              disabled={
                isAnyDeviceRunning && deviceStates[device.key] !== "Stop"
              }
            >
              {deviceStates[device.key] || "Start"}
            </Button>
          </Col>
        </Row>
      ))}
    </React.Fragment>
  );
};

export default DeviceSection;
